import { useEffect, useState } from 'react';

import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Input, InputGroup } from 'components/FormComponents';

const defaultNextActionDate = () => moment().add(2, 'days').format('YYYY-MM-DD');

export const NextActionModal = ({
  visible,
  currentValue = null,
  onClose = () => {},
  onSave = () => {},
}) => {
  const { t } = useTranslation();
  const [date, setDate] = useState('');

  useEffect(() => {
    if (visible) {
      setDate(currentValue ? moment(currentValue).format('YYYY-MM-DD') : defaultNextActionDate());
    }
  }, [visible, currentValue]);

  const normalizedCurrentValue = currentValue ? moment(currentValue).format('YYYY-MM-DD') : '';
  const dateUnchanged = !!date && date === normalizedCurrentValue;
  const hasExistingValue = !!normalizedCurrentValue;

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('admin.candidate.check.nextAction.title', 'Next Action')}
      small>
      <div className="d-flex flex-column u-gap-medium">
        <InputGroup title={t('admin.candidate.check.nextAction.date', 'Next action date')}>
          <Input
            type="date"
            name="next_action_at"
            inputProps={{
              value: date,
              onChange: e => setDate(e.target.value),
            }}
          />
        </InputGroup>
        <div className="d-flex u-gap justify-content-end u-margin-top--small">
          {hasExistingValue && (
            <Button type="delete" onClick={() => onSave({ next_action_at: null })}>
              {t('admin.candidate.check.nextAction.clear', 'Clear')}
            </Button>
          )}
          <Button type="secondary" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button
            type="primary"
            onClick={() => onSave({ next_action_at: date || null })}
            disabled={!date || dateUnchanged}>
            {t('common.save')}
          </Button>
        </div>
      </div>
    </AnimatedModal>
  );
};
